<template>
    <div class="dropdown">
        <a-dropdown :trigger="['click']">
            <a-menu slot="overlay" class="drop-list" theme="dark">
                <a-menu-item 
                    v-for="(item, index) in dropList" 
                    :key="index"
                    style="font-size:12px;color:#a9a9a9;"
                    class="drop-list-item"
                    @click="checkoutIndex(index)"
                    >{{item}}
                </a-menu-item>
            </a-menu>
            <div class="trigger-btn">{{initSelect}}<a-icon style="fontSize:11px;position:absolute;right:10px;top:5px;" type="down" /></div>
        </a-dropdown>
    </div>
</template>

<script>
import event from  '../event'
export default {
    data() {
        return {
            dropList: ['上证指数', '深证成指', '创业板指', '上证50指数'],
            initSelect: '叠加指数'
        }
    },
    props: {
        name: String
    },
    mounted() {
        this.dropList = (this.name === 'northShare' || this.name === 'north') ? ['叠加指数' ,'上证指数', '深证成指', '创业板指', '上证50指数'] : ['叠加指数' ,'恒生指数', '恒生综合大型指数', '恒生综合中型指数', '恒生综合小型指数']
    },
    methods: {
        checkoutIndex(index) {
            this.initSelect = this.dropList[index]
            this.sendSel(this.name)
        },
        sendSel(name) {
            event.set('selcted' + name, this.initSelect)
        }
    },
}
</script>

<style lang="less">
.dropdown {
    font-family: SimSun;
    .trigger-btn {
        width: 147px;
        height: 20px;
        line-height: 18px;
        background: #171b1d;
        border: 1px solid #313131;
        font-size: 12px;
        padding-left: 15px;
        color: #a9a9a9;
        font-family: SimSun;    
        &:hover {
            cursor: pointer;
        }
    }
}
.newblack{
    .dropdown{
        .trigger-btn{
            background: #fff;
            border: 1px solid #cbcbe1;
            color: #272841;
        }
    }
}
.newgrey{
    .dropdown{
        .trigger-btn{
            background: #181c21;
            border: 1px solid #1f2228;
            color: #d0d1d2;
        }
    }
}
.ant-dropdown {
    font-family: SimSun;
}
.ant-dropdown .ant-dropdown-menu-dark{
    background-color: #171b1d;
    border: 1px solid #313131;
} 
.newblack .ant-dropdown .ant-dropdown-menu-dark{
    background-color: #ffffff;
    border: 1px solid #cbcbe1;
} 
.newblack .ant-dropdown .ant-dropdown-menu-dark li{
    color: #272841 !important;
}
.newblack .ant-dropdown-menu-dark .ant-dropdown-menu-item:hover{
    background-color: #d4e1f8 !important;
} 

.newgrey .ant-dropdown .ant-dropdown-menu-dark{
    background-color: #181c21;
    border: 1px solid #1f2228;
} 
.newgrey .ant-dropdown .ant-dropdown-menu-dark li{
    color: #fff !important;
}
.newgrey .ant-dropdown-menu-dark .ant-dropdown-menu-item:hover{
    background-color: #34517d !important;
} 
</style>
